import { createContext, useContext } from 'react';
import Store from '../stores';

export const StoreContext = createContext(Store);
export const StoreProvider = StoreContext.Provider;
export const useStores = () => useContext(StoreContext);
